module.exports = __webpack_public_path__ + "core-img/modal-aside.329fc0f61cb5d694b6b699ee165808d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/gfx/modal-aside.png
// module id = 89
// module chunks = 0